import { useDispatch, useSelector } from 'react-redux';
import { Select } from '../../../../@core/components/form/Select';
import { ModelSelect } from '../../../../views/addons/ModelSelect';
import { RadioList } from '../../../../views/addons/RadioList';
import { removeError } from '../../../../redux/actions/validator';
import { editCollectionRegister } from '../../../../redux/actions/form';

const vehicle = [
  {
    type: 'card',
    collection: ['vehicle'],
    subTitle: 'Datos del vehículo',
    card: [
      {
        col: [12],
        component: () => <RadioList {...{ name: 'vehicleType' }} />,
      },
      {
        col: [12, 6, 6],
        name: 'brandStr',
        condition: ['vehicleType||eq||Moto'],
        label: 'Marca',
      },
      {
        col: [12, 6, 6],
        name: 'brand',
        condition: ['vehicleType||eq||Car'],
        label: 'Marca',
        type: 'select',
        endPoint: 'brands',
      },
      {
        col: [12, 6, 6],
        name: 'enrollmentDate',
        label: 'Fecha matriculación',
        type: 'date',
      },
      {
        col: [12, 6, 6],
        name: 'fuel',
        label: 'Tipo de motor',
        customOptions: [
          { label: 'DIESEL', value: 'D' },
          { label: 'ELÉCTRICO', value: 'Elc' },
          { label: 'GASOLINA', value: 'G' },
          { label: 'GASOLINA GLP-CNG', value: 'S' },
          { label: 'ETANOL Y GASOLINA', value: 'M' },
          { label: 'HÍBRIDO DIESEL-ELÉCTRICO', value: 'DyE' },
          { label: 'HÍBRIDO GASOLINA-ELÉCTRICO', value: 'GyE' },
        ],
        component: (props) => {
          const { name, collection } = props;
          const dispatch = useDispatch();
          const { form, select, validator } = useSelector((state) => state);
          const handleSelect = (target) => {
            const value = target ? target.value : null;
            if (validator.errors && validator.errors[name])
              delete validator.errors[name];
            dispatch(editCollectionRegister(collection, { name, value }));
            dispatch(removeError(validator.errors));
            dispatch(
              editCollectionRegister(['vehicle'], {
                name: 'modelId',
                value: null,
              }),
            );
            dispatch(
              editCollectionRegister(['vehicle'], {
                name: 'modelStr',
                value: null,
              }),
            );
          };

          return <Select {...props} onSelect={handleSelect} />;
        },
      },
      {
        col: [12, 6, 6],
        name: 'modelStr',
        condition: ['vehicleType||eq||Moto'],
        label: 'Modelo',
      },
      {
        col: [12, 6, 6],
        condition: ['vehicleType||eq||Car'],
        component: ModelSelect,
      },
      {
        col: [12, 6, 6],
        name: 'kw',
        condition: ['vehicleType||eq||Moto', 'fuel||eq||Elc'],
        label: 'Potencia (kw)',
        type: 'number',
      },
      {
        col: [12, 6, 6],
        name: 'cc',
        condition: ['vehicleType||eq||Moto', 'fuel||ne||Elc'],
        label: 'Cilindrada (cc)',
        type: 'number',
      },
      {
        col: [12, 6, 6],
        name: 'ccaaId',
        label: 'Comunidad Autónoma',
        type: 'select',
        endPoint: 'ccaa',
      },
      {
        col: [12, 6, 6],
        name: 'plate',
        label: 'Matrícula',
      },
      // {
      //     col: [12, 6, 6],
      //     name: 'use_type',
      //     label: 'Tipo de uso',
      //     type: 'select',
      //     customOptions: [
      //         { label: 'Uso Particular y otros', value: 'AL' },
      //         { label: 'Alquiler sin Conductor', value: 'AS' },
      //         { label: 'Enseñamiento', value: 'EN' },
      //         { label: 'Autotaxi', value: 'TX' }
      //     ]
      // },
    ],
  },
  {
    type: 'card',
    collection: ['buyer'],
    card: [
      {
        col: [12],
        name: 'email',
        label: 'Correo',
      },
    ],
  },
];

export default vehicle;
